module.exports = __webpack_public_path__ + "static/baaramewe-white-d5c2183b5655f19f512815109d734181.png";